import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { FaDuotoneIconComponent } from '@fortawesome/angular-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faChevronDown } from '@fortawesome/pro-duotone-svg-icons';

/**
 * A lightweight expansion panel: a clickable header with an optional leading
 * icon, a projected title (any element marked with the `panel-title`
 * attribute), and a rotating chevron; the default-slot body is shown while
 * `expanded` is true.
 *
 * Projection note: the body content is instantiated eagerly by the declaring
 * component — the internal `@if` only attaches/detaches it from the DOM, so
 * its state survives collapse/expand cycles.
 *
 * For accordion semantics drive `expanded` from the parent with an
 * always-accepting handler, e.g.
 * `[expanded]="open() === 'audio'" (expandedChange)="open.set($event ? 'audio' : null)"`
 * — re-toggling logic in the handler can desync the internal model, since
 * the input only writes back when the bound expression's value changes.
 */
@Component({
  selector: 'andor-expansion-panel',
  standalone: true,
  imports: [FaDuotoneIconComponent],
  templateUrl: './expansion-panel.html',
  styleUrl: './expansion-panel.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpansionPanel {
  expanded = model(false);
  icon = input<IconDefinition | null>(null);

  protected readonly faChevronDown = faChevronDown;

  protected toggle() {
    this.expanded.update((v) => !v);
  }
}
